module.exports = __webpack_public_path__ + "static/uia-ec379ed571e8e1f03f32b9f88eb10993.jpg";